"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSubAccounts = exports.decodeTokenCurrencyId = exports.decodeTokenAssetId = exports.getTokenAssetId = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const operation_1 = require("../../operation");
const logic_1 = require("./logic");
const typhonjs_1 = require("@stricahq/typhonjs");
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const account_1 = require("../../account");
const lodash_1 = require("lodash");
const jsHelpers_1 = require("../../bridge/jsHelpers");
const getTokenAssetId = ({ policyId, assetName, }) => `${policyId}${assetName}`;
exports.getTokenAssetId = getTokenAssetId;
const decodeTokenAssetId = (id) => {
    const policyId = id.slice(0, 56);
    const assetName = id.slice(56);
    return { policyId, assetName };
};
exports.decodeTokenAssetId = decodeTokenAssetId;
const encodeTokenCurrencyId = (parentCurrency, assetId) => `${parentCurrency.id}/native/${assetId}`;
const decodeTokenCurrencyId = (id) => {
    const [parentCurrencyId, type, assetId] = id.split("/");
    return {
        parentCurrencyId,
        type,
        assetId,
    };
};
exports.decodeTokenCurrencyId = decodeTokenCurrencyId;
/**
 * @returns operations of tokens that are defined in ledgerjs cryptoassets
 */
const mapTxToTokenAccountOperation = ({ parentAccountId, parentCurrency, newTransactions, accountCredentialsMap, }) => {
    const operations = [];
    newTransactions.forEach(tx => {
        const accountChange = (0, logic_1.getAccountChange)(tx, accountCredentialsMap);
        accountChange.tokens.forEach(token => {
            const assetId = (0, exports.getTokenAssetId)({
                policyId: token.policyId,
                assetName: token.assetName,
            });
            const tokenCurrencyId = encodeTokenCurrencyId(parentCurrency, assetId);
            const tokenCurrency = (0, cryptoassets_1.findTokenById)(tokenCurrencyId);
            // skip the unsupported tokens by ledger-live
            if (tokenCurrency === null || tokenCurrency === undefined) {
                return;
            }
            const tokenAccountId = (0, account_1.encodeTokenAccountId)(parentAccountId, tokenCurrency);
            const tokenOperationType = token.amount.lt(0) ? "OUT" : "IN";
            const memo = (0, logic_1.getMemoFromTx)(tx);
            const extra = {};
            if (memo) {
                extra.memo = memo;
            }
            const operation = {
                accountId: tokenAccountId,
                id: (0, operation_1.encodeOperationId)(tokenAccountId, tx.hash, tokenOperationType),
                hash: tx.hash,
                type: tokenOperationType,
                fee: new bignumber_js_1.default(tx.fees),
                value: token.amount.absoluteValue(),
                senders: tx.inputs.map(i => (0, logic_1.isHexString)(i.address) ? typhonjs_1.utils.getAddressFromHex(i.address).getBech32() : i.address),
                recipients: tx.outputs.map(o => (0, logic_1.isHexString)(o.address) ? typhonjs_1.utils.getAddressFromHex(o.address).getBech32() : o.address),
                blockHeight: tx.blockHeight,
                date: new Date(tx.timestamp),
                extra,
                blockHash: undefined,
            };
            operations.push(operation);
        });
    });
    return operations;
};
function buildSubAccounts({ initialAccount, parentAccountId, parentCurrency, newTransactions, tokens, accountCredentialsMap, }) {
    var _a;
    const tokenAccountsById = {};
    if (initialAccount && initialAccount.subAccounts) {
        for (const existingAccount of initialAccount.subAccounts) {
            if (existingAccount.type === "TokenAccount") {
                tokenAccountsById[existingAccount.id] = existingAccount;
            }
        }
    }
    const tokenOperations = mapTxToTokenAccountOperation({
        parentAccountId,
        parentCurrency,
        newTransactions: newTransactions,
        accountCredentialsMap,
    });
    const tokenOperationsByAccId = (0, lodash_1.groupBy)(tokenOperations, o => o.accountId);
    const tokensBalanceByAssetId = (0, lodash_1.keyBy)(tokens, t => (0, exports.getTokenAssetId)(t));
    for (const tokenAccountId in tokenOperationsByAccId) {
        const initialTokenAccount = tokenAccountsById[tokenAccountId];
        const oldOperations = (initialTokenAccount === null || initialTokenAccount === void 0 ? void 0 : initialTokenAccount.operations) || [];
        const newOperations = tokenOperationsByAccId[tokenAccountId] || [];
        const operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
        const { token: tokenCurrency } = (0, account_1.decodeTokenAccountId)(tokenAccountId);
        if (tokenCurrency) {
            const accountBalance = ((_a = tokensBalanceByAssetId[tokenCurrency.contractAddress]) === null || _a === void 0 ? void 0 : _a.amount) || new bignumber_js_1.default(0);
            const tokenAccount = {
                type: "TokenAccount",
                id: tokenAccountId,
                parentId: parentAccountId,
                token: tokenCurrency,
                balance: accountBalance,
                spendableBalance: accountBalance,
                creationDate: operations.length > 0 ? operations[operations.length - 1].date : new Date(),
                operationsCount: operations.length,
                operations,
                pendingOperations: [],
                starred: false,
                balanceHistoryCache: account_1.emptyHistoryCache,
                swapHistory: [],
            };
            tokenAccountsById[tokenAccountId] = tokenAccount;
        }
    }
    return Object.values(tokenAccountsById);
}
exports.buildSubAccounts = buildSubAccounts;
//# sourceMappingURL=buildSubAccounts.js.map